import __var_0__ from '@stdlib/assert/is-number';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isNumber = __var_0__.isObject;


// MAIN //

/**
* Tests if a value is a number object having a negative value.
*
* @param {*} value - value to test
* @returns {boolean} boolean indicating if a value is a number object having a negative value
*
* @example
* var bool = isNegativeNumber( -3.0 );
* // returns false
*
* @example
* var bool = isNegativeNumber( new Number( -3.0 ) );
* // returns true
*/
function isNegativeNumber( value ) {
	return (
		isNumber( value ) &&
		value.valueOf() < 0.0
	);
}


// EXPORTS //
export default isNegativeNumber;
